import * as React from 'react'
import * as ReactDOM from 'react-dom'
import * as PropTypes from 'prop-types'
import VirtualTable from 'src/packages/virtualtable/VirtualTable'

const componentName = 'VirtualTableExample'

class VirtualTableExample extends React.Component<any, any> {
  public static displayName = componentName

  public static defaultProps = {}

  public static propTypes = {}

  constructor(props: any) {
    super(props)
    const dataSource = Array.from(
      { length: 100000 },
      (val: any, index: number) => {
        return {
          key: `dataSource${index + 1}`,
          name: `John ${index + 1}`,
          age: Math.floor(Math.random() * 20 + 20 - 1),
          column1: 'column 1',
          column2: 'column 2',
          column3: 'column 3',
          address: `浙江省杭州市西湖区湖底公园1号`
        }
      }
    )
    this.state = {
      dataSource,
      columns: [
        {
          title: '姓名',
          key: 'name',
          sort: true,
          width: 250,
          fixed: 'left',
          headStyle: { display: 'inline-flex' },
          style: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
          }
        },
        {
          title: '年龄',
          key: 'age',
          sort: true,
          width: 100,
          headStyle: { display: 'inline-flex' },
          style: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
          }
        },
        {
          title: 'Col 1',
          key: 'column1',
          width: 100,
          style: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
          }
        },
        {
          title: 'Col 2',
          key: 'column2',
          width: 100,
          style: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
          }
        },
        {
          title: 'Col 3',
          key: 'column3',
          width: 100,
          style: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
          }
        },
        {
          title: '住址',
          key: 'address',
          width: 0,
          style: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            fontSize: '12px'
          }
        }
      ]
    }
  }

  public render() {
    const cn = componentName
    const { columns, dataSource } = this.state
    return (
      <div className="virtualtable-example">
        <section>
          <h1>VirtualTable 虚拟表格</h1>
          <p className="text">展示行列数据。</p>
        </section>
        <section>
          <h2>何时使用</h2>
          <p className="text">需要展示大量结构化的数据时。</p>
        </section>
        <section>
          <h2>代码示例</h2>
        </section>
        <div className="example">
          <div className="container" style={{ display: 'block' }}>
            <VirtualTable
              columns={columns}
              dataSource={dataSource}
              height={800}
              rowHeight={40}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default VirtualTableExample



// WEBPACK FOOTER //
// ./src/examples/VirtualTable.example.tsx